import { FORM_ERROR } from "final-form";

/**
 * This function serves as an adapter between the response returned
 * by rtk-query and the submissionError object expected by final-form.
 * @param {Error} error - the error thrown by rtk-query.
 * @returns {Object} - the submissionError object expected by final-form. Example: https://github.com/final-form/react-final-form/blob/main/examples/submission-errors/index.js
 */
export const rtkQueryReponseToSubmissionError = ({ error }) => {
  if (error?.originalStatus === 500 || error?.status === 500) {
    return {
      [FORM_ERROR]: "We're sorry, but something went wrong.",
    };
  }
  if (error?.status === 400) {
    // The `data` must match the shape of form fields the error to be displayed correctly.
    return error.data;
  }

  throw error;
};
